var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "compare-header"
  }, [_c('div', {
    staticClass: "compare-header__wrap"
  }, [_c('button', {
    staticClass: "compare-header__back",
    on: {
      "click": function ($event) {
        return _vm.$emit('back');
      }
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "compare-header__title"
  }, [_vm._v("\n      " + _vm._s(_vm.title)), _c('span', {
    staticClass: "compare-header__title_sup"
  }, [_vm._v(_vm._s(_vm.count))])])]), _vm._v(" "), _c('div', {
    staticClass: "compare-buttons"
  }, [_c('button', {
    staticClass: "compare-buttons__item",
    on: {
      "click": function ($event) {
        return _vm.$emit('share');
      }
    }
  }, [_c('div', {
    staticClass: "compare-buttons__item-icon-share"
  })]), _vm._v(" "), _c('button', {
    staticClass: "compare-buttons__item",
    on: {
      "click": function ($event) {
        return _vm.$emit('delete');
      }
    }
  }, [_c('div', {
    staticClass: "compare-buttons__item-icon-delete"
  })])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }